import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NoteType } from '../../../models/note-type.enum';
import { AuthService } from "../../../../services/auth.service";
import { NoteFilter } from '../../../models/note.model';



@Component({
    selector: 'notes-filter',
    templateUrl: './notes-filter.component.html',
    styleUrls: ['./notes-filter.component.scss'],
    standalone: false
})
export class NotesFilterComponent implements OnInit {


    currentFilter: NoteFilter = {
        fromDate: null,
        toDate: new Date(),
        userName: "",
        type: ""
    } as NoteFilter;

    filterOpened: boolean = false;


    @Input() flowOnBehalf: boolean = false;

    @Output() onFiltering: EventEmitter<NoteFilter> = new EventEmitter<NoteFilter>();


    @Input() typeKeys: NoteType[];

    _keys: any[];

    types = NoteType;

    get typeFilter(): any[] {
        if (this._keys == null || this._keys.length === 0) {
            this._keys = [];
            this._keys.push({ id: "", value: "" });
            this.typeKeys.forEach(k => {
                this._keys.push({ id: k, value: this.types[k] });
            })
        }
        return this._keys;
    }

    @Input() shownNotes: number = 0;
    @Input() totalNotes: number = 0;
    

    @Input() userNames: string[] = [];



    constructor() { }

    ngOnInit() {
    }

    filterChanged(evt: any): void {
        this.onFiltering.emit(this.currentFilter);
    }

    onFromDateChanged(evt: Date) : void{
        this.currentFilter.fromDate = evt;
        this.filterChanged(evt);
    }

    onToDateChanged(evt: Date): void {
        evt.setHours(23);
        evt.setMinutes(59);
        evt.setSeconds(59);
        this.currentFilter.toDate = evt;
        this.filterChanged(evt);
    }

    toggleFiltering(open: boolean): void {
        this.filterOpened = open;
    }

}
